import { c as _c } from "react/compiler-runtime";
import { useFetcherV2 } from "@website/fetcher/use-fetcherV2";
import { applicationStore, LoginStatus } from "@website/store/store";
import { useWebengage } from "@website/tracking/tracking.webengage.hook";
import { getChannel } from "@website/utils/channel/get-channel";
import { setChannel } from "@website/utils/channel/set-channel";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { convertToken, useAuthSessionRefresh, useLoginStatus } from "./utils";
setChannel();
export const useAuthPages = () => {
  const $ = _c(18);
  const router = useRouter();
  const {
    loginStatus
  } = useLoginStatus();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getChannel();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const currentChannel = t0;
  const t1 = router?.query?.ispwa;
  let t2;
  if ($[1] !== t1) {
    t2 = toString(t1);
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isPwa = t2;
  const t3 = router?.query?.app_version;
  let t4;
  if ($[3] !== t3) {
    t4 = toString(t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const appVersion = t4;
  const t5 = router?.query?.token;
  let t6;
  if ($[5] !== t5) {
    t6 = toString(t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const queryToken = t6;
  useConvertTokenPages();
  let t7;
  if ($[7] !== queryToken || $[8] !== router.asPath) {
    t7 = {
      routeChangeKey: router.asPath,
      queryToken
    };
    $[7] = queryToken;
    $[8] = router.asPath;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  useAuthSessionRefresh(t7);
  let t8;
  let t9;
  if ($[10] !== appVersion || $[11] !== isPwa) {
    t8 = () => {
      if (isPwa) {
        applicationStore.applicationData.isPwa.set(isPwa === "true");
      }
      if (appVersion) {
        applicationStore.applicationData.appVersion.set(appVersion);
      }
    };
    t9 = [isPwa, appVersion];
    $[10] = appVersion;
    $[11] = isPwa;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[14] !== loginStatus || $[15] !== router.pathname) {
    t10 = () => {
      const channel = getChannel();
      const channelHasRedirectState = channel === "b2b" || channel === "telesale";
      if (channelHasRedirectState && loginStatus === LoginStatus.LoggedOut && router.pathname !== "/b2b-login") {
        window.location.href = "/b2b-login";
      }
    };
    t11 = [loginStatus, router.pathname, currentChannel];
    $[14] = loginStatus;
    $[15] = router.pathname;
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  useEffect(t10, t11);
};
export const useConvertTokenPages = () => {
  const $ = _c(11);
  const router = useRouter();
  const {
    login
  } = useWebengage();
  const t0 = router.query?.token;
  let t1;
  if ($[0] !== t0) {
    t1 = toString(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const queryToken = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getChannel();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== queryToken) {
    t3 = ["auth-cookie", "convert-token", t2, queryToken];
    $[3] = queryToken;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== login || $[6] !== queryToken) {
    t4 = async () => {
      await convertToken(queryToken, login);
    };
    $[5] = login;
    $[6] = queryToken;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = {
      queryKey: t3,
      enabled: true,
      queryFn: t4
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useFetcherV2(t5);
};